import { BookOpen, Search, Wrench, Hammer, TrendingUp, Home, Shield } from "lucide-react";
const modules = [{
  icon: BookOpen,
  number: "01",
  title: "LOS CIMIENTOS",
  subtitle: "Entiende el crédito como lo entienden los bancos, no como te lo explican en YouTube.",
  description: "Rompiendo Mitos y Entendiendo el Juego - Por qué el crédito es tu mejor aliado, no tu enemigo.",
  highlights: ["FICO vs. VantageScore: Las reglas secretas", "El impacto real: $1,000+ en ahorros", "Vocabulario esencial Inglés-Español"]
}, {
  icon: Search,
  number: "02",
  title: "DIAGNÓSTICO",
  subtitle: "Descubre exactamente dónde estás parado y qué errores están frenando tu score.",
  description: "¿Dónde Estás Parado Hoy? Aprende a leer entre líneas tus reportes de crédito.",
  highlights: ["Equifax, Experian, TransUnion explicados", "Obtén tus 3 reportes GRATIS", "La fórmula secreta del score"]
}, {
  icon: Wrench,
  number: "03",
  title: "EL PLAN DE RESCATE",
  subtitle: "Las estrategias que realmente funcionan para limpiar tu historial y subir tu score.",
  description: "Reparando Tu Crédito Paso a Paso - Disputas, correcciones y el mazo de la justicia.",
  highlights: ["Cartas que las agencias NO ignoran", "Estrategias Pay for Delete 2024", "CFPB: Tu perro guardián federal"]
}, {
  icon: Hammer,
  number: "04",
  title: "CONSTRUCCIÓN DESDE CERO",
  subtitle: "Empieza sin historial y construye un crédito sólido aunque acabes de llegar.",
  description: "Para Inmigrantes y Principiantes - El camino con ITIN y cómo transicionar después.",
  highlights: ["Tarjetas aseguradas 2024", "El truco del Usuario Autorizado", "Tu plan de 90 días"]
}, {
  icon: TrendingUp,
  number: "05",
  title: "ESTRATEGIAS AVANZADAS",
  subtitle: "Técnicas de expertos para llevar tu score a niveles que desbloquean las mejores ofertas.",
  description: "Llevando Tu Score a 750+ - La regla de oro de la utilización y timing perfecto.",
  highlights: ["Nunca superes el 10% (no el 30%)", "Aumentos de línea sin dañar score", "Optimización para auto o casa"]
}, {
  icon: Home,
  number: "06",
  title: "EL CRÉDITO EN LA VIDA REAL",
  subtitle: "Cómo usar tu crédito para conseguir auto, casa y financiamiento sin que te estafen.",
  description: "Aplicaciones Prácticas - Tu primer auto, preparación para hipoteca, crédito para negocios.",
  highlights: ["Evita trampas Buy Here Pay Here", "Lo que buscan los bancos 12 meses antes", "Alquiler con mal crédito"]
}, {
  icon: Shield,
  number: "07",
  title: "PROTECCIÓN Y MANTENIMIENTO",
  subtitle: "Protege lo que construiste y mantén tu score alto de por vida.",
  description: "Hábitos para Toda la Vida - Robo de identidad, psicología del dinero y herramientas 2024.",
  highlights: ["Cómo congelar tu crédito HOY", "Hábitos que los ricos tienen", "Apps y herramientas gratis vs pagas"]
}];
const ModulesSection = () => {
  return <section className="relative overflow-hidden section-padding bg-[hsl(215,12%,40%)]">
      {/* Background dots pattern */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0" style={{
        backgroundImage: `radial-gradient(circle, rgba(255,255,255,0.3) 1px, transparent 1px)`,
        backgroundSize: '20px 20px'
      }} />
      </div>
      <div className="container-centered relative z-10">
        {/* Section Header */}
        <div className="mb-12 text-center">
          <span className="inline-block rounded-full bg-gradient-to-r from-teal-500 via-cyan-400 to-amber-500 px-4 py-2 text-slate-900 font-extrabold text-xl">
            Contenido del Sistema
          </span>
          <h2 className="mt-4 font-display font-bold text-foreground sm:text-3xl lg:text-4xl text-4xl">
            7 Módulos Para{" "}
            <span className="bg-gradient-to-r from-teal-400 via-cyan-300 to-amber-400 bg-clip-text text-transparent font-extrabold">
Dominar Tu Crédito</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl font-extrabold text-primary-foreground text-2xl">
            Todo lo que necesitas saber, en el orden correcto, para dejar de cometer errores y empezar a ver resultados reales en tu crédito en EE.UU.
          </p>
        </div>

        {/* Modules Grid */}
        <div className="flex flex-wrap justify-center gap-6">
          {modules.map((module, index) => <div key={index} className="group relative w-full overflow-hidden rounded-2xl bg-card p-6 shadow-card transition-all duration-300 hover:-translate-y-1 hover:shadow-glow sm:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)]">
              {/* Module Number Badge */}
              <div className="absolute -right-4 -top-4 flex h-20 w-20 items-center justify-center rounded-full bg-gradient-to-br from-teal-500/10 via-cyan-400/10 to-amber-500/10 font-display text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-teal-400 to-amber-400">
                {module.number}
              </div>

              {/* Icon + Title aligned */}
              <div className="mb-3 flex items-center gap-3">
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-gradient-to-r from-teal-500/20 via-cyan-400/20 to-amber-500/20 text-cyan-400 transition-colors group-hover:bg-gradient-to-r group-hover:from-teal-500 group-hover:via-cyan-400 group-hover:to-amber-500 group-hover:text-slate-900">
                  <module.icon className="h-7 w-7" />
                </div>
                <h3 className="font-display text-lg font-bold text-secondary-foreground">
                  {module.title}
                </h3>
              </div>
              {'subtitle' in module && module.subtitle && (
                <p className="mb-2 text-xs text-cyan-400 font-semibold text-center">
                  {module.subtitle}
                </p>
              )}
              <p className="mb-4 text-sm text-secondary-foreground font-extrabold">
                {module.description}
              </p>

              {/* Highlights */}
              <ul className="space-y-2">
                {module.highlights.map((highlight, hIndex) => <li key={hIndex} className="flex items-center gap-2 text-sm">
                    <div className="h-1.5 w-1.5 rounded-full bg-gradient-to-r from-teal-400 to-amber-400" />
                    <span className="text-secondary-foreground font-extrabold">{highlight}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
};
export default ModulesSection;